import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import {request} from "../../util/APIUtils";
import {RightExists, showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import './Income.css';
import classnames from "classnames";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import FeeForm from "./FeeForm";
import TransactionTypeForm from "./TransactionTypeForm";
import {Button, Dropdown, Menu} from "antd";
import Icon from "antd/es/icon";
import TransactionTypeDeleteModal from "./TransactionTypeDeleteModal";
import FinancialDeleteModal from "./FinancialDeleteModal";

class FinancialParameters extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            deleteModal:false,
            mode: 'create',
            loading: false,
            addDeleteModal: false,
            selectedItem: null,
            selectedFeeDefinition: null,
            selectedTransactionType: null,
            feeDefinitions: [],
            transactionTypes: [],
            searching: false,
            searching2: false,
            searchQuery: undefined,
            searchQuery2: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addFeeModal: false,
            total2: 0,
            page2: 0,
            size2: 10,
            manual2: false,
            addTransactionModal: false,
            func: null,
            activeTab: '1',
        };

        this.toggle = this.toggle.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearch2 = this.handleSearch2.bind(this);
        this.listFeeDefinitions = this.listFeeDefinitions.bind(this);
        this.addNew = this.addNew.bind(this);
        this.addNewTransactionType = this.addNewTransactionType.bind(this);
        this.cancelTransactionTypeCreation = this.cancelTransactionTypeCreation.bind(this);
        this.cancelFeeCreation = this.cancelFeeCreation.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.listTransactionTypes = this.listTransactionTypes.bind(this);
    }
    componentDidMount() {
        this.listFeeDefinitions();
        this.listTransactionTypes();
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listFeeDefinitions(this.state.accessor2, this.state.direction2, this.state.page2, this.state.size2))
    }

    handleSearch2(searchQuery2) {
        this.setState({
            searchQuery2,
            searching2: true
        }, () => this.listTransactionTypes(this.state.accessor, this.state.direction, this.state.page2, this.state.size2))
    }

    addNew() {
        let self = this;
        self.setState({
            selectedFeeDefinition: null,
            addFeeModal: true,
            func: "editFeeDefiniton",
        })
    }

    addNewTransactionType() {
        console.log("inside addNewTransactionType");
        let self = this;
        self.setState({
            selectedTransactionType: null,
            addTransactionModal: true,
        })
    }

    handleEdit(item, func) {
        let self = this;
        console.log("item", item);
        self.setState({
            selectedFeeDefinition: item,
            addFeeModal: true,
            func: func,
        })
    }

    handleEdit2(item) {
        let self = this;
        console.log("item", item);
        self.setState({
            selectedTransactionType: item,
            addTransactionModal: true,
        })
    }

    listFeeDefinitions(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=id,asc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + '/fee-definition/fetchFeeDefinitions?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                console.log(response.data);
                let feeDefinitions = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    feeDefinitions,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    listTransactionTypes(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=id,asc';
        let searchQuery2 = !self.state.searchQuery2 ? '' : '&' + self.state.searchQuery2;
        let params = {
            url: API_BASE_URL + '/transaction-type/fetchTransactionTypes?page=' + page + '&size=' + size + sortStr + searchQuery2,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                console.log(response.data);
                let transactionTypes = response.data.content;
                self.setState({
                    page2: page,
                    size2: size,
                    total2: response.data.totalElements,
                    transactionTypes,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    cancelFeeCreation() {
        this.setState({
            selectedFeeDefinition: null,
            addFeeModal: false,
            deleteModal:false,
        })
        this.listFeeDefinitions()
    }
    handleDelete2(item) {
        this.setState({
            selectedTransactionType: item,
            addDeleteModal: true
        })
    }
    handleDelete(item) {
        this.setState({
            selectedFeeDefinition: item,
            deleteModal:true,
        })
    }
    cancelTransactionTypeCreation() {
        this.setState({
            selectedTransactionType: null,
            addTransactionModal: false,
            addDeleteModal: false,
        })
        this.listTransactionTypes()
    }

    toggle(tab) {

        this.setState({
            activeTab: tab
        })
    }
    handleLogout() {
        this.props.handleLogout();
    }
    render() {
        const {feeDefinitions} = this.state;
        const {transactionTypes} = this.state;

        const transactionDirectionTypes = [
            {value: null, label: "Tümü"},
            {value: 'INCOME', label: "GELİR"},
            {value: 'EXPENSE', label: "GİDER"},];

        const menu = (
            <Menu>
                <Menu.Item onClick={() => this.handleEdit(this.state.selectedItem, "editFeeDefiniton")}>
                    Aidat Düzenle
                </Menu.Item>
                <Menu.Item onClick={() => this.handleEdit(this.state.selectedItem, "createAccrual")}>
                    Yıllık Tahakkuk Oluştur
                </Menu.Item>
                <Menu.Item onClick={() => this.handleDelete(this.state.selectedItem)}>
                    Aidat Silme
                </Menu.Item>
            </Menu>
        );
        const menu2 = (
            <Menu>
                <Menu.Item onClick={() => this.handleEdit2(this.state.selectedItem)}>
                    Gelir-Gider Tipi Düzenle
                </Menu.Item>
                <Menu.Item onClick={() => this.handleDelete2(this.state.selectedItem)}>
                    Gelir-Gider Tipi Silme
                </Menu.Item>
            </Menu>
        );

        const FeeDefinitonColumns = [
            {
                Header: "Aidat Dönemi",
                accessor: "feeYear",
            },
            {
                Header: "Tutar",
                accessor: "",
                Cell: item => (
                    <label>{item.amount && item.amount.toString().replace('.', ',') + ' ₺'}</label>)
            },
            {
                Header: "Yıllık Tahakkuk Oluşturulma Durumu",
                accessor: "",
                Cell: item => (
                    <label>{item.feeAccrualGenerationStatus &&
                    item.feeAccrualGenerationStatus === "NOT_STARTED" ? "OLUŞTURULMADI" :
                        (item.feeAccrualGenerationStatus === "STARTED" || item.feeAccrualGenerationStatus === "SCHEDULED") ? "OLUŞTURULUYOR" : "OLUŞTURULDU"}</label>
                )
            },
            {
                Header: "Yıllık Tahakkuk Oluşturulma Tarihi",
                accessor: "",
                Cell: item => (
                    <label>{item.feeAccrualGenerationDate ? new Date(item.feeAccrualGenerationDate.toString().substring(0, item.feeAccrualGenerationDate.toString().indexOf('T'))).toLocaleDateString('tr') : "-"}</label>
                )
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu}
                                  trigger='click'
                                  onClick={() => this.setState({selectedItem: item})}
                        >
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }
        ];

        const FeeDefinitonFields = [
            {
                label: "Aidat Dönemi",
                accessor: "feeYear",
                type: "text",
                operator: "=",
            },
            {
                label: "Tutar",
                accessor: "amount",
                type: "text",
                operator: "=",
            },
        ];
        const transactionTypeColumns = [
            {
                Header: "Sıra",
                accessor: "id",
            },
            {
                Header: "Ad",
                accessor: "name",

            },
            {
                Header: "Gelir/Gider",
                accessor: "",
                Cell: item => (
                    <label style={{
                        fontWeight: 'bold',
                        color: (item.transactionDirectionType === 'INCOME') ? 'green' : 'red'
                    }}>{(item.transactionDirectionType === 'INCOME') ? 'GELİR' : 'GİDER'}</label>
                )
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu2}
                                  trigger='click'
                                  onClick={() => this.setState({selectedItem: item})}
                        >
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }
        ];

        const transactionTypeFields = [

            {
                label: "Ad",
                accessor: "name",
                type: "text",
                operator: "=",
            },
            {
                label: "Gelir/Gider",
                accessor: "transactionDirectionType",
                type: "select",
                operator: "=",
                selectData: transactionDirectionTypes,
            }
        ];

        return (
            <div className='user-form-container'>
                <div>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({active: this.state.activeTab === '1'})}
                                onClick={() => {
                                    this.toggle('1');
                                }}>
                                Yıllık Aidat Tanımı
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({active: this.state.activeTab === '2'})}
                                onClick={() => {
                                    this.toggle('2');
                                }}>
                                Gelir-Gider Tipleri
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab} className="tab-content">

                        <TabPane tabId="1">
                            <div className="FeeList-container">
                                <div className="row baseBackground">
                                    <div className="col-md-12 satirBasi">
                                        <div className="card-header ">
                                            <h4 className="card-title">Aidat Tanım Listesi</h4>
                                        </div>
                                        <div className="card-body mt-1">
                                            <div className=" ">
                                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                                    <DetailedSearch fields={FeeDefinitonFields}
                                                                    loading={this.state.searching}
                                                                    onSearch={this.handleSearch}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <Table
                                                loading={this.state.loading}
                                                loadingText="Kayıtlar getiriliyor..."
                                                content={feeDefinitions}
                                                total={this.state.total}
                                                page={this.state.page}
                                                manual={this.state.manual}
                                                size={this.state.size}
                                                options={["5", "10", "20", "50", "100"]}
                                                columns={FeeDefinitonColumns}
                                                fetchData={this.listFeeDefinitions}
                                                style={{width:"100%"}}
                                            />
                                        </div>
                                    </div>
                                    {
                                        (RightExists("ROLE_RIGHT_CHAMBER_CREATE", this.props.authorities))
                                        &&
                                        <div className="new-button-holder">
                                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                                    title="Yeni Aidat Tanımla" disabled={this.state.isLoading}
                                                    style={{
                                                        background: 'linear-gradient(#2b93cd, #0a66b7)',
                                                        height: '40px',
                                                        width: '160px',
                                                        float: 'right',
                                                        marginRight: '30px',
                                                        color: 'white',
                                                        borderRadius: '0.375em',
                                                    }}
                                                    className="TekBtn add-new-member "
                                                    rel="tooltip"
                                                    onClick={() => this.addNew(this.state.selectedItem)}>
                                            YENİ AİDAT EKLE
                                            </button>
                                        </div>
                                    }
                                    <Modal isOpen={this.state.addFeeModal} size="lg" className="ust">
                                        <ModalHeader
                                            toggle={this.cancelFeeCreation}>{(this.state.func && this.state.func === 'createAccrual') ? 'Yıllık Aidat Tahakkuklarını Oluştur' : 'Aidat Tanımla'}</ModalHeader>
                                        <ModalBody>
                                            <FeeForm cancelProcess={this.cancelFeeCreation}
                                                     selectedFeeDefinition={this.state.selectedFeeDefinition}
                                                     currentUser={this.props.currentUser}
                                                     handleSearch={this.handleSearch}
                                                     func={this.state.func}
                                                     triggerDownloadRequestTooltip={this.props.triggerDownloadRequestTooltip}/>
                                        </ModalBody>
                                    </Modal>
                                    <Modal isOpen={this.state.deleteModal} size="lg" className="ust">
                                        <ModalHeader toggle={this.cancelFeeCreation}>
                                            Aidat Silme
                                        </ModalHeader>
                                        <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                                            <FinancialDeleteModal
                                                cancelProcess={this.cancelFeeCreation}
                                                selectedFeeDefinition={this.state.selectedFeeDefinition}
                                                handleLogout={this.handleLogout}/>
                                        </ModalBody>
                                    </Modal>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="TransactionTypeList-container">
                                <div className="row baseBackground">
                                    <div className="col-md-12 satirBasi">
                                        <div className="card-header ">
                                            <h4 className="card-title">Gelir-Gider Tipi Listesi</h4>
                                        </div>
                                        <div className="card-body mt-1">
                                            <div className=" ">
                                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                                    <DetailedSearch fields={transactionTypeFields}
                                                                    loading={this.state.searching2}
                                                                    onSearch={this.handleSearch2}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <Table
                                                loading={this.state.loading}
                                                loadingText="Kayıtlar getiriliyor..."
                                                content={transactionTypes}
                                                total={this.state.total2}
                                                page={this.state.page2}
                                                manual={this.state.manual2}
                                                size={this.state.size2}
                                                options={["5", "10", "20", "50", "100"]}
                                                columns={transactionTypeColumns}
                                                fetchData={this.listTransactionTypes}
                                                style={{width:"100%"}}
                                            />
                                        </div>
                                    </div>
                                    {
                                        (RightExists("ROLE_RIGHT_FINANCIAL_PARAMETERS_CREATE", this.props.authorities))
                                        &&
                                        <div className="new-button-holder">
                                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                                    title="Yeni Aidat Tanımla" disabled={this.state.isLoading}
                                                    style={{
                                                        background: 'linear-gradient(#2b93cd, #0a66b7)',
                                                        height: '40px',
                                                        width: '230px',
                                                        float: 'right',
                                                        marginRight: '30px',
                                                        color: 'white',
                                                        borderRadius: '0.375em',
                                                    }}
                                                    className="TekBtn add-new-member "
                                                    rel="tooltip"
                                                    onClick={() => this.addNewTransactionType()}>
                                                YENİ GELİR-GİDER TİPİ EKLE
                                            </button>
                                        </div>
                                    }
                                    <Modal isOpen={this.state.addTransactionModal} size="lg" className="ust">
                                        <ModalHeader toggle={this.cancelTransactionTypeCreation}>Gelir-Gider Tipi
                                            Tanımı</ModalHeader>
                                        <ModalBody>
                                            <TransactionTypeForm cancelProcess={this.cancelTransactionTypeCreation}
                                                                 selectedTransactionType={this.state.selectedTransactionType}
                                                                 currentUser={this.props.currentUser}
                                                                 handleSearch={this.handleSearch2}
                                                                 mode={this.state.mode}/>
                                        </ModalBody>
                                    </Modal>
                                    <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                                        <ModalHeader toggle={this.cancelTransactionTypeCreation}>
                                            Gelir-Gider Tipi Silme
                                        </ModalHeader>
                                        <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                                            <TransactionTypeDeleteModal
                                                cancelProcess={this.cancelTransactionTypeCreation}
                                                selectedTransactionType={this.state.selectedTransactionType}
                                                handleLogout={this.handleLogout}/>
                                        </ModalBody>
                                    </Modal>
                                </div>
                            </div>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        )
    }
}

export default FinancialParameters;


// WEBPACK FOOTER //
// ./src/page/financial/FinancialParameters.js